import React from 'react';
import { Container, Typography, Box, Paper, Divider, Stack } from '@mui/material';

export default function TermsOfService() {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
        <Typography variant="h4" component="h1" fontWeight={700} gutterBottom>
          Terms of Service
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          Last Updated: January 30, 2026
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Stack spacing={4}>
          <Box>
            <Typography variant="h5" fontWeight={600} gutterBottom>1. Agreement to Terms</Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              By accessing our website at Questguru (operated by Arithmetic Infotech), you agree to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" fontWeight={600} gutterBottom>2. Accepting These Terms</Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              By using Questguru (operated by Arithmetic Infotech) you agree to these Terms of Service and our Privacy Policy. If you are under 13, you must have parental or guardian permission to use the service.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" fontWeight={600} gutterBottom>3. Account Safety &amp; Parental Controls</Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              Users are responsible for maintaining the confidentiality of their account credentials. Parents and guardians are responsible for supervising accounts of children. If a parent wishes to limit data collection or request deletion for a child, contact support and we will assist promptly.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" fontWeight={600} gutterBottom>4. Acceptable Use</Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              You must use the service for lawful, educational purposes only. Do not attempt to interfere with the safety or operation of the site, harvest data from other users, reverse-engineer our systems, or engage in any abusive behavior. Violations may lead to account suspension or termination.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" fontWeight={600} gutterBottom>5. Exam Integrity and Aspirants</Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              Questguru is designed to support honest study practices for exam aspirants. You must not use the platform to obtain or share confidential exam content, answer keys, or any material that would constitute cheating according to exam authorities. Attempting to use our tools to circumvent exam rules or share restricted content is strictly prohibited and may result in immediate account suspension and reporting to relevant authorities where required by law.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              We use performance and interaction data to provide personalized study guidance; this data will be treated in accordance with our Privacy Policy and will not be used to facilitate cheating or unauthorized disclosures.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" fontWeight={600} gutterBottom>5. Content, Accuracy &amp; Educational Use</Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              Our content and AI-generated materials are educational aids. We strive for accuracy but do not guarantee results. Users should verify critical information with official sources and instructors.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" fontWeight={600} gutterBottom>6. Limitation of Liability</Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              To the fullest extent permitted by law, Arithmetic Infotech is not liable for indirect or consequential losses. Our liability for direct losses is limited to the amount you have paid for the service (if any) during the 12 months preceding a claim.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" fontWeight={600} gutterBottom>7. Data Protection &amp; Privacy</Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              Our Privacy Policy explains how we collect and handle data. We take special care to protect children's data and to limit collection to what is necessary for learning outcomes.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" fontWeight={600} gutterBottom>8. Termination and Suspension</Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              We may suspend or terminate accounts that violate these terms or pose security risks. Users may delete their accounts at any time; data removal requests are processed in accordance with our Privacy Policy.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" fontWeight={600} gutterBottom>9. Changes to These Terms</Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              We may update these Terms occasionally. We will provide notice of significant changes and obtain consent where required by law.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" fontWeight={600} gutterBottom>10. Contact</Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              For questions about these terms, or to report concerns about a child’s account, contact: support@arithmeticinfotech.com.
            </Typography>
          </Box>
        </Stack>
      </Paper>
    </Container>
  );
}
